import {
  // location map
  UPDATE_SELECTED_PLACE,
  // UPDATE_SHOW_ALL_PLACES,
  RESET_SELECTED_PLACES,
  SHOW_ONLY_USER_SELECTED_LOCATIONS,
  SHOW_ALL_NEARBY_PLACES,
} from './types';

// export const updateShowAllPlaces = showAllPlaces => {
//   return {
//     type: UPDATE_SHOW_ALL_PLACES,
//     payload: {
//       showAllPlaces,
//     },
//   };
// };

export const updateSelectedPlaces = places => {
  return {
    type: UPDATE_SELECTED_PLACE,
    payload: {
      places,
    },
  };
};

export const showAllNearbyPlaces = nearbyPlaces => {
  return {
    type: SHOW_ALL_NEARBY_PLACES,
    payload: {
      selectedPlaces: nearbyPlaces,
    },
  };
};

export const resetSelectedPlaces = () => {
  return {
    type: RESET_SELECTED_PLACES,
  };
};

export const showOnlyUserSelectedLocations = () => {
  return {
    type: SHOW_ONLY_USER_SELECTED_LOCATIONS,
  };
};
